import { Link } from "wouter";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white border-t border-slate-700">
      <div className="container py-16 md:py-20 px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-6 relative">
              Quick Links
              <div className="absolute bottom-0 left-0 w-12 h-1 bg-gradient-to-r from-orange-400 to-orange-600 rounded-full"></div>
            </h3>
            <ul className="space-y-3">
              <li>
                <Link href="/products" className="text-slate-300 hover:text-orange-400 transition-all duration-300 hover:translate-x-1 inline-block">
                  Products
                </Link>
              </li>
              <li>
                <Link href="/services" className="text-slate-300 hover:text-orange-400 transition-all duration-300 hover:translate-x-1 inline-block">
                  Services
                </Link>
              </li>
              <li>
                <Link href="/about" className="text-slate-300 hover:text-orange-400 transition-all duration-300 hover:translate-x-1 inline-block">
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/faq" className="text-slate-300 hover:text-orange-400 transition-all duration-300 hover:translate-x-1 inline-block">
                  FAQ
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-slate-300 hover:text-orange-400 transition-all duration-300 hover:translate-x-1 inline-block">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-6 relative">
              Contact Info
              <div className="absolute bottom-0 left-0 w-12 h-1 bg-gradient-to-r from-orange-400 to-orange-600 rounded-full"></div>
            </h3>
            <ul className="space-y-4">
              <li className="text-slate-300">
                <span className="block font-medium text-white">Address</span>
                112, Harmukhpuri, Modinagar<br />
                Ghaziabad, UP-201204
              </li>
              <li className="text-slate-300">
                <span className="block font-medium text-white">Phone</span>
                9319021546
              </li>
              <li className="text-slate-300">
                <span className="block font-medium text-white">Email</span>
                rambahadur.panday@peworx.com
              </li>
            </ul>
          </div>
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-6 relative">
              About Us
              <div className="absolute bottom-0 left-0 w-12 h-1 bg-gradient-to-r from-orange-400 to-orange-600 rounded-full"></div>
            </h3>
            <p className="text-slate-300 leading-relaxed">
              Leading manufacturer of textile machinery parts with over 20 years of experience in delivering precision engineering solutions for the modern textile industry.
            </p>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-slate-700 text-center">
          <p className="text-slate-400">&copy; {new Date().getFullYear()} Panday Engineering Works. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
